var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationLikes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationLikes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.90544266,4.59229232 C4.32986466,4.1533436 4.88790066,3.93357174 5.44669266,3.93357174 C6.00548466,3.93357174 6.56632866,4.15334449 6.99075966,4.59229232 L7.49981766,5.12038056 L8.00888466,4.59507174 C8.85773766,3.7171574 10.2453488,3.71717696 11.0941928,4.59507174 C11.9430458,5.4729674 11.9430458,6.8829243 11.0941928,7.76082085 C9.93901584,8.95553209 8.78436066,10.1515775 7.62919266,11.346262 C7.59519095,11.3817847 7.54789298,11.4019109 7.49841366,11.4019109 C7.44893434,11.4019109 7.40163637,11.3817847 7.36763466,11.346262 L3.90544266,7.75803699 C3.05756169,6.87946093 3.05658969,5.47017376 3.90544266,4.59229232 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-62.000000, -282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNotificationLikes",
    transform: "translate(62.000000, 281.998500)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#7BCB45",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationLikes);
export default __webpack_public_path__ + "static/media/icNotificationLikes.ff144178ca536a9903c61ef8dcd94578.svg";
export { ForwardRef as ReactComponent };